<template>

    <div>
        <div class="text-center margin-bottom">
            <div class="btn-group btn-group-xs">
                <button class="btn btn-default" type="button" @click="prevYear()"><i class="fa fa-chevron-left"></i></button>
                <button class="btn btn-default" type="button">{{ getOvertimeYear }}</button>
                <button class="btn btn-default" :disabled="!canGoToNextYear" type="button" @click="nextYear()"><i class="fa fa-chevron-right"></i></button>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6">
                <overtime-quarter
                    :quarter="1"
                    ref="overtimeQuarter1"
                />
            </div>
            <div class="col-xl-6">
                <overtime-quarter
                    :quarter="2"
                    ref="overtimeQuarter2"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6">
                <overtime-quarter
                    :quarter="3"
                    ref="overtimeQuarter3"
                />
            </div>
            <div class="col-xl-6">
                <overtime-quarter
                    :quarter="4"
                    ref="overtimeQuarter4"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-xl-offset-3">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">{{ lang.get('timeregistration.overtime.totalheader') }} {{ getOvertimeYear }}</h2>
                    </div>
                    <div class="box-body no-padding">
                        <table class="table table-striped" v-if="!isLoading">
                            <thead>
                                <tr>
                                    <th class="text-center">{{ lang.get("timeregistration.overtime.quarter") }}</th>
                                    <th class="text-center">{{ lang.get("timeregistration.overtime.registeredhours") }}</th>
                                    <th class="text-center">{{ lang.get("timeregistration.overtime.holidayhours") }}</th>
                                    <th class="text-center">{{ lang.get("timeregistration.overtime.plannedholidayhours") }}</th>
                                    <th class="text-center">{{ lang.get("timeregistration.overtime.contracthours") }}</th>
                                    <th class="text-center">{{ lang.get("timeregistration.overtime.overtime") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="quarter in getTotals">
                                    <td class="text-center">{{ quarter.quarter }}</td>
                                    <td class="text-center">{{ quarter.totalTimeregistrationHours }}</td>
                                    <td class="text-center">{{ quarter.totalHolidayhours }}</td>
                                    <td class="text-center">{{ quarter.totalPlannedHolidayHours }}</td>
                                    <td class="text-center">{{ quarter.totalContracthours }}</td>
                                    <td class="text-center">{{ quarter.totalOvertime }}</td>
                                </tr>
                            </tbody>
                            <tfoot style="font-weight:700;">
                                <tr>
                                    <td class="text-right">{{ lang.get("global.total") }}</td>
                                    <td class="text-center">{{ totalTimeregistrationHours }}</td>
                                    <td class="text-center">{{ totalHolidayhours }}</td>
                                    <td class="text-center">{{ totalPlannedHolidayHours }}</td>
                                    <td class="text-center">{{ totalContracthours }}</td>
                                    <td class="text-center">{{ totalOvertime }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="box-body">
                        <p>
                            {{ lang.get("timeregistration.overtime.totalvacationhours") }}:
                            <strong>{{ availableVacationHours }}</strong>
                        </p>
                        <p v-if="automaticallyIncludeOvertime">
                            {{ lang.get('timeregistration.overtime.totalvacationhoursincludingovertime') }}:
                            <strong>{{ availableVacationHours + totalOvertime }}</strong>
                        </p>
                        <p>
                            {{ lang.get("timeregistration.overtime.remainingvacationhours") }}:
                            <strong>{{ remainingVacationHours }}</strong>
                        </p>
                        <p>
                            {{ lang.get("timeregistration.overtime.remainingvacationhoursminusplanned") }}:
                            <strong>{{ remainingVacationHoursMinusPlanned }}</strong>
                        </p>
                    </div>
                    <div class="overlay" v-if="isLoading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import axios from 'axios';
    import moment from 'moment';
    import OvertimeQuarter from "./OvertimeQuarter";
    import Lang from '../../Lang';

    export default {

        components:{
            OvertimeQuarter,
        },

        computed: {
            ...mapGetters([
                "getOvertimeYear",
                "isLoading",
            ]),

            canGoToNextYear() {
                return parseInt(this.getOvertimeYear) <= parseInt(moment().format("YYYY"));
            },

            getTotals() {
                if (this.isLoading || !this.loaded) {
                    return [];
                }
                let totals = [];
                [1,2,3,4].forEach(quarter => {
                    let ref = 'overtimeQuarter' + quarter;
                    totals.push(this.$refs[ref].getTotals());
                });
                return totals;
            },

            remainingVacationHours() {
                if (this.automaticallyIncludeOvertime === true) {
                    return (this.availableVacationHours + this.totalOvertime) - this.totalHolidayhours;
                }

                return this.availableVacationHours - this.totalHolidayhours;
            },

            remainingVacationHoursMinusPlanned() {
                return this.remainingVacationHours - this.totalPlannedHolidayHours;
            },

            totalTimeregistrationHours() {
                let total = 0;
                this.getTotals.forEach((ot) => total += ot.totalTimeregistrationHours);
                return total;
            },
            totalHolidayhours() {
                let total = 0;
                this.getTotals.forEach((ot) => total += ot.totalHolidayhours);
                return total;
            },
            totalContracthours() {
                let total = 0;
                this.getTotals.forEach((ot) => total += ot.totalContracthours);
                return total;
            },
            totalOvertime() {
                let total = 0;
                this.getTotals.forEach((ot) => total += ot.totalOvertime);
                return total;
            },
            totalPlannedHolidayHours() {
                let total = 0;
                this.getTotals.forEach((ot) => total += ot.totalPlannedHolidayHours);
                return total;
            },
        },

        data() {
            return {
                lang:Lang,
                loaded:false,
                availableVacationHours:0,
            }
        },

        methods: {
            ...mapActions([
                "setLoading",
                "setOvertime",
                "setOvertimeYear",
            ]),

            fetchOvertime(){
                axios.get(this.overtimeUri,{params:{year:this.getOvertimeYear}})
                    .then(response => {
                        this.setOvertime(response.data.data.overtime);
                        this.availableVacationHours = response.data.data.totalvacationhours;
                        this.setLoading(false);
                        this.loaded = true;
                    });
            },

            nextYear() {
                this.setLoading(true);
                this.setOvertimeYear(parseInt(this.getOvertimeYear) + 1);
                this.fetchOvertime();
            },

            prevYear() {
                this.setLoading(true);
                this.setOvertimeYear(parseInt(this.getOvertimeYear) - 1);
                this.fetchOvertime();
            },

        },

        mounted() {
            this.setOvertimeYear(moment().format("YYYY"));
            this.fetchOvertime();
        },

        name: "Overtime",

        props: {
            automaticallyIncludeOvertime: {
                required:true,
                type:Boolean,
            },
            overtimeUri: {
                required:true,
                type:String,
            },
        }
    }

</script>
